import React from 'react';
import PropTypes from 'prop-types';
import style from './Loading.module.css';

const LoadingLocal = ({ message }) => (
  <div className={style.loadingLocal}>
    <div className={`${style.spinning} fas fa-circle-o-notch fa-spin fa-4x`} />
    { message && <div className={style.label}>{ message }</div>}
  </div>
);

LoadingLocal.propTypes = {
  message: PropTypes.string,
};

export default LoadingLocal;
